<div class="menu">
  <input [formControl]="url" type="text" />
</div>
<div class="container">
  <div (pointerdown)="makePoint($event)" id="frame">
    <img [src]="url.value" />
  </div>

  <div id="photo">
    <div id="transform">
      <div class="sample"></div>
      <svg
        height="210mm"
        viewBox="0 0 2970 2100"
        width="297mm"
        xmlns="http://www.w3.org/2000/svg"
      >
        <defs>
          <filter
            color-interpolation-filters="linearRGB"
            filterUnits="objectBoundingBox"
            height="140%"
            id="filter2"
            primitiveUnits="userSpaceOnUse"
            width="140%"
            x="-20%"
            y="-20%"
          >
            <feFlood flood-color="#black" flood-opacity=".7" result="flood" />
            <feComposite
              in="flood"
              in2="SourceAlpha"
              operator="out"
              result="composite1"
            />
            <feOffset dx="-1" dy="2" in="composite1" result="offset" />
            <feGaussianBlur
              edgeMode="none"
              in="offset"
              result="blur"
              stdDeviation="1 1"
            />
            <feComposite
              in="blur"
              in2="SourceAlpha"
              operator="in"
              result="composite2"
            />

            <feMerge result="merge">
              <feMergeNode in="SourceGraphic" />
              <feMergeNode in="composite2" />
            </feMerge>
            <feTurbulence
              baseFrequency="0.01 0.05"
              numOctaves="1"
              result="turbulence"
              seed="1"
              stitchTiles="noStitch"
              type="turbulence"
            />
            <feDisplacementMap
              in="merge"
              in2="turbulence"
              result="displacementMap"
              scale="1"
              xChannelSelector="G"
              yChannelSelector="A"
            />
          </filter>
          <filter
            height="200%"
            id="inset-shadow"
            width="200%"
            x="-50%"
            y="-50%"
          >
            <feComponentTransfer in="SourceAlpha">
              <feFuncA tableValues="1 0" type="table" />
            </feComponentTransfer>
            <feGaussianBlur stdDeviation="1" />
            <feOffset dx="0" dy="1" result="offsetblur" />

            <feFlood flood-color="rgb(0, 0, 0)" result="color" />
            <feComposite in2="offsetblur" operator="in" />
            <feComposite in2="SourceAlpha" operator="in" />
            <feMerge>
              <feMergeNode in="SourceGraphic" />
              <feMergeNode />
            </feMerge>
          </filter>
          <filter
            height="200%"
            id="innershadow"
            width="120%"
            x0="-50%"
            y0="-50%"
          >
            <feComponentTransfer in="SourceAlpha">
              <feFuncA tableValues="1 0" type="table" />
            </feComponentTransfer>
            <feGaussianBlur stdDeviation="0.5" />
            <feOffset dx="0" dy="1" result="offsetblur" />
            <feOffset dx="1" dy="0" result="offsetblur2" />
            <feFlood flood-color="rgb(20, 0, 0)" result="color" />
            <feComposite in2="offsetblur" operator="in" />
            <feComposite in2="offsetblur2" operator="in" />
            <feComposite in2="SourceAlpha" operator="in" />
            <feMerge>
              <feMergeNode in="SourceGraphic" />
              <feMergeNode />
            </feMerge>
          </filter>
          <pattern
            height="1080px"
            id="img1"
            patternUnits="userSpaceOnUse"
            width="2500"
          >
            <image
              height="3000"
              href="/assets/test/zloto.png"
              width="6500"
              x="-1200"
              y="-500"
            />
          </pattern>
        </defs>
        <path
          d="M12 4.435c-1.989-5.399-12-4.597-12 3.568 0 4.068 3.06 9.481 12 14.997 8.94-5.516 12-10.929 12-14.997 0-8.118-10-8.999-12-3.568z"
          fill="url(#img1)"
          filter="url(#filter2)"
        />
        <g fill="url(#img1)" filter="url(#filter2)" id="Warstwa_x0020_1">
          <metadata id="CorelCorpID_0Corel-Layer"></metadata>
          <g id="_1915817242384">
            <path
              class="fil0 str0"
              d="M1481.798 821.674c-7.868,-7.871 -20.434,-8.164 -28.687,-0.895 -8.246,-7.269 -20.819,-6.976 -28.693,0.895 -8.199,8.203 -8.199,21.492 0,29.692l28.693 28.686 28.687 -28.686c8.216,-8.2 8.216,-21.489 0,-29.692z"
            ></path>
            <polygon
              class="fil0 str0"
              points="1456.511,790.145 1449.704,790.145 1449.704,584.674 1456.511,584.674 "
            ></polygon>
            <polygon
              class="fil0 str0"
              points="1456.511,1110.099 1449.704,1110.099 1449.704,904.637 1456.511,904.637 "
            ></polygon>
          </g>
          <text
            class="fil1 fnt0"
            style="font-size: 728px"
            x="745.882"
            y="1113.308"
          >
            A
          </text>
          <text
            class="fil1 fnt0"
            style="font-size: 728px"
            x="1680.074"
            y="1112.879"
          >
            T
          </text>
          <text class="fil1 fnt1" x="968.735" y="1514.884">11.03.2021</text>

          <text class="fil1 fnt2" x="1485" y="1350">ANNA &amp; TOMASZ</text>
        </g>
      </svg>
    </div>
  </div>
</div>
